module.exports = __webpack_public_path__ + "img/trees.76068b4a.jpg";